<template>
  <div>
    <el-tabs
      type="border-card"
      stretch
      v-model="activeName"
      @tab-click="handleClick"
      v-if="!isShow"
    >
      <el-tab-pane name="major">
        <span slot="label">
          助学专业：
          <span class="num">
            {{
              totalCount && totalCount.major && totalCount.major.majorCount
            }}个
          </span>
        </span>
        <TotalTable :type="'major'" :tableData="totalCount.major"></TotalTable>
        <Select @change="handleSearch" @export="handleExport"></Select>
        <Table
          :type="'major'"
          :tableData="tableData"
          @changes="handleChangeClasss"
        ></Table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.pageSize"
          @pagination="handleChangeSize"
        />
      </el-tab-pane>
      <el-tab-pane name="school">
        <span slot="label">
          合作院校 ：
          <span class="num">
            {{
              totalCount && totalCount.school && totalCount.school.schoolCount
            }}个
          </span>
        </span>
        <TotalTable
          :type="'school'"
          :tableData="totalCount.school"
        ></TotalTable>
        <Select type="school"  @export="handleExport"></Select>
        <Table
          :type="'school'"
          :tableData="tableData"
          @changes="handleChangeClasss"
        ></Table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.pageSize"
          @pagination="handleChangeSize"
        />
      </el-tab-pane>
      <el-tab-pane name="company">
        <span slot="label">
          合作机构：
          <span class="num">
            {{ totalCount && totalCount.mhm && totalCount.mhm.mhmCount }}个
          </span>
        </span>
        <TotalTable :type="'company'" :tableData="totalCount.mhm"></TotalTable>
        <Select type="company"  @export="handleExport"></Select>
        <Table
          :type="'company'"
          :tableData="tableData"
          @changes="handleChangeClasss"
        ></Table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.pageSize"
          @pagination="handleChangeSize"
        />
      </el-tab-pane>
    </el-tabs>
    <classList
      v-if="isShow"
      :majorCode="majorCode"
      :majorName="majorName"
      :listType="activeName"
    ></classList>
  </div>
</template>

<script>
import TotalTable from "./TotalTable.vue";
import Select from "./select.vue";
import Table from "./Table.vue";
import pagination from "./Pagination/index.vue";
import classList from "./classList.vue";
import {
  getAlbumTotalCount,
  getAlbumMajorList,
  getAlbumSchoolList,
  getAlbumMhmList,
} from "@/api/TeachingStatistics";
export default {
  components: {
    TotalTable,
    Select,
    Table,
    pagination,
    classList,
  },
  props: {
    listType: { type: String, default: "" },
    isReset: { type: Boolean, default: false },
    isReflesh: { type: Boolean, default: false },
    // totalCount:{  type: Object,default:()=>{return {}}},
    forms: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      activeName: "major",
      tableData: [],
      totalCount: {},
      total: 0,
      queryParams: { pageSize: 10, page: 1 },
      isShow: false,
      majorName: "", // 专业名称
      majorCode: "", // 专业编码
      newForms: this.forms
    };
  },
  computed: {
    url() {
      let url = window.location.protocol + "//" + window.location.host;
      if (window.location.host == "localhost:5001"  ) {
        url = "http://gz.hnjk.net";
      }
      return url;
    },
  },
  methods: {
    // 标签页切换
    async handleClick(page) {
      this.isShow = false;
      this.queryParams.page = 1;
      let that = this;
      this.$emit('update:isReflesh',false)
      if(page&&page>1){this.queryParams.page = page}
      const {data} = await getAlbumTotalCount(this.forms)
      if(data.code === 100000){
        this.totalCount = data.data;
      }
      if (this.activeName === "major") {
        const {data} = await getAlbumMajorList({
          ...that.forms,
          ...that.queryParams,
        });
        if(data.code === 100000){
          this.tableData = data.data.list;
          this.total = data.data.total;
        }
      }else if (this.activeName === "school") {
        const {data} = await getAlbumSchoolList({ 
            ...that.forms,
            ...that.queryParams}
        );
        if(data.code === 100000){
          this.tableData = data.data.list;
          this.total = data.data.total;
        }
      } else if (this.activeName === "company") {
        const {data} = await getAlbumMhmList({ ...that.forms, ...that.queryParams});
        if(data.code === 100000){
          this.tableData = data.data.list;
          this.total = data.data.total;
        }
      }
    },
    /** 搜索/重置事件 */
    async handleSearch(params) {
      if (this.activeName === "major") {
        const {data} = await getAlbumMajorList({
          ...this.forms,
          ...params,
          ...this.queryParams,
        });
        if(data.code === 100000){
          this.tableData = data.data.list;
          this.total = data.data.total;
        }
      }
      if (this.activeName === "school") {
        const {data} = await getAlbumSchoolList({
          ...this.forms,
          ...params,
          ...this.queryParams,
        });
        if(data.code === 100000){
          this.tableData = data.data.list;
          this.total = data.data.total;
        }
      }
      if (this.activeName === "company") {
        const {data} = await getAlbumMhmList({
          ...this.forms,
          ...params,
          ...this.queryParams,
        });
        if(data.code === 100000){
          this.tableData = data.data.list;
          this.total = data.data.total;
        }
      }
    },
    /** 点击专业班级 */
    handleChangeClasss(val) {
      this.isShow = true;
      this.$emit("update:isReset", false);
      if (this.activeName === "major") {
        this.majorName = val.majorName;
        this.majorCode = val.majorCode;
      } else if (this.activeName === "school") {
        this.majorName = val.schoolName;
      } else if (this.activeName === "company") {
        this.majorName = val.mhmName;
      }
    },
    /** 导出结果 */
    handleExport(form) {
      this.forms = form;
      if(this.activeName==='major'){
        window.open(
          `${this.url}/zkfz/statistics/albumMajorListExport?courseGroupCode=${form.courseGroupCode}&degreeName=${form.degreeName}&eduLevel=${form.eduLevel}&enrollMajorCode=${form.enrollMajorCode}&mainSchoolCode=${form.mainSchoolCode}&mainSchoolName=${form.mainSchoolName}&majorCode=${form.majorCode}&majorName=${form.majorName}&schoolId=${this.forms.schoolId!==undefined?this.forms.schoolId:""}&timeRange=${this.forms.timeRange!==undefined?this.forms.timeRange:""}&startTime=${this.forms.startTime!==undefined?this.forms.startTime:""}&endTime=${this.forms.endTime!==undefined?this.forms.endTime:""}`
        );
      }else if(this.activeName==='school'){
         window.open(
        `${this.url}/zkfz/statistics/albumSchoolListExport?courseGroupCode=${form.courseGroupCode}&degreeName=${form.degreeName}&eduLevel=${form.eduLevel}&enrollMajorCode=${form.enrollMajorCode}&mainSchoolCode=${form.mainSchoolCode}&mainSchoolName=${form.mainSchoolName}&majorCode=${form.majorCode}&majorName=${form.majorName}&schoolId=${this.forms.schoolId!==undefined?this.forms.schoolId:""}&timeRange=${this.forms.timeRange!==undefined?this.forms.timeRange:""}&startTime=${this.forms.startTime!==undefined?this.forms.startTime:""}&endTime=${this.forms.endTime!==undefined?this.forms.endTime:""}`
         )
      }else if(this.activeName==='company'){
         window.open(
        `${this.url}/zkfz/statistics/albumMhmListExport?courseGroupCode=${form.courseGroupCode}&degreeName=${form.degreeName}&eduLevel=${form.eduLevel}&enrollMajorCode=${form.enrollMajorCode}&mainSchoolCode=${form.mainSchoolCode}&mainSchoolName=${form.mainSchoolName}&majorCode=${form.majorCode}&majorName=${form.majorName}&schoolId=${this.forms.schoolId!==undefined?this.forms.schoolId:""}&timeRange=${this.forms.timeRange!==undefined?this.forms.timeRange:""}&startTime=${this.forms.startTime!==undefined?this.forms.startTime:""}&endTime=${this.forms.endTime!==undefined?this.forms.endTime:""}`
         )
      }
    },
    /** 分页事件 */
    handleChangeSize(page){
      this.handleClick(page.page)
    }
  },
  mounted() {
    // this.handleClick();
  },
  watch: {
    listType: function (val) {
      this.isShow = false;
    },
    isReset: function (val) {
      if (val) {
        this.isShow = false;
      }
    },
    forms: {
      handler(newValue,oldValue){
        this.newForms = newValue;
        if(this.isReflesh){
          setTimeout(()=>{
            this.handleClick()
          },2000)
        }
      },
      deep: true,
      immediate:true
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
  background-color: #64b0ff;
  span {
    color: #fff;
    .num {
      font-size: 24px;
      font-weight: 700;
      color: red;
    }
    .num:hover {
      color: #409eff;
    }
  }
}
::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #d7d7d7;
  border: 0;
  span {
    color: #000;
    .num {
      color: red;
    }
  }
}
::v-deep .el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
::v-deep .el-tabs--border-card > .el-tabs__header {
  height: 70px;
  padding-top: 30px;
  margin-top: 3px;
}
</style>